export default __webpack_public_path__ + "static/media/72-Romy.1f2dc49b.jpg";